export default function ({ route, env }) {
    let layout = route.matched.map((r) => {
        return (r.components.default.options ? r.components.default.options.layout : r.components.default.layout);
    })[0] || null;

    // We don't need the chat in embeddable widgets
    if (layout === 'widget') {
        return;
    }

    let script = document.createElement('script');
    script.attributes.defer = true;
    script.src = `https://www.scribbr.com/wp-content/themes/scribbr-2017/js/chat.js?${env.buildNr}`;
    document.body.appendChild(script);
}
